export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const USER_LOADED = "USER_LOADED";
export const USER_LOADING = "USER_LOADING";
export const AUTH_ERROR = "AUTH_ERROR";
export const SUBMISSION_SUCCESS = "SUBMISSION_SUCCESS";
export const FORM_SUBMISSION = "FORM_SUBMISSION";
